module.exports = __webpack_public_path__ + "static/media/Praktikumsbescheinigung.31e1d60c.pdf";